import { initialStateBase, reducer } from './newCollection';

const initialState = { ...initialStateBase };

export const urls = {
    getStaticMapUrl: '/api/maps/static/sign',
    getEmbedMapUrl: '/api/maps/embed/google',
    staticMapUrl: '/external/base/img//$theme$/seller-card-map_3x.png',
    staticDesktopMapUrl: '/external/base/img//$theme$/static_map.png',
    staticLetgoDesktopMapUrl: '/external/base/img//$theme$/static_map_otoplus.png',
    staticLetgoMobileMapUrl: '/external/base/img//$theme$/static_map_mobile.png'
};

export default (state = initialState, action) => reducer(state, action, 'MAPS');
